import { ComponentType } from "../types";

export const isActivityComponentChangeableFromUI = (component: ComponentType): boolean => component !== "ReadonlyText";
